export const CHANGE_SERVICE_AT  = 'CHANGE_DATE_RANGE_SERVICE_AT_REPORTS_TAB';
export const SELECT_CUSTOMERS   = 'SELECT_CUSTOMERS_REPORTS_TAB';
export const SELECT_TEMPLATES   = 'SELECT_TEMPLATES_REPORTS_TAB';
export const RESET_CONDITIONS   = 'RESET_CONDITIONS_REPORTS_TAB';
export const SEARCH_REPORTS     = 'SEARCH_REPORTS_REPORTS_TAB';
export const CHANGE_TEMPLATE_REPORTS = 'CHANGE_TEMPLATE_REPORTS';
export const REMOVE_REPORTS     = 'REMOVE_REPORTS';
export const PRINT_REPORTS      = 'PRINT_REPORTS';